import script from "./SettingsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsDetails.vue?vue&type=style&index=0&id=c0bfbddc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0bfbddc"]])

export default __exports__